<template>
  <div class="main-container email-table-height">
    <transition :css="false">
    <el-dialog title="Edit Email" :visible.sync="editModal" width="40%">
      <form>
        <arnergy-dynamic
          v-model="form.groupID"
          label="Select Group"
          :items="groups"
          @subgroup="getSubgroupss"
        />
        <div v-show="form.groupID" class="form-check ml-3">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            v-model="form.status"
            id="defaultCheck1"
          />
          <label class="form-check-label" for="defaultCheck1">
            Do you want to edit Subgroup to Email ?
          </label>
        </div>

        <br />
        <div v-show="form.status">
          <arnergy-select
            v-model="form.subgroup"
            label="Subgroup"
            :items="subgroups"
          />
        </div>

        <div class="form-group">
          <label>Email Address</label>
          <input
            type="text"
            v-model="form.emailaddress"
            style="height: 5rem;"
            class="form-control"
          />
        </div>
        <br />

        <arnergy-select
          v-model="form.sendtype"
          label="Send Type"
          :items="sendtypes"
        />

        <div class="mt-5 form-check ml-3">
          <input
            class="form-check-input"
            v-model="form.status2"
            type="checkbox"
            value=""
            id="defaultCheck1"
          />
          <label class="form-check-label" for="defaultCheck1">
            {{ form.status2 ? 'Disable Group' : 'Enable Group' }}
          </label>
        </div>
        <div class="pt-4 text-right">
          <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <button class="btn btn-primary" @click="updateGroup">
              Edit Email
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
    </transition>
    <div style="width: 100%;">
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        a
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="getEmails"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <!-- {{1}} -->
          <span v-if="props.column.field == 'actions'">
            <b-button
              size="md"
              variant="success"
              @click="editmodal(props.row.id)"
            >
              Edit Email &nbsp;
              <span class="fa fa-wrench"></span>
            </b-button>
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import moment from 'moment'
import ArnergyDynamic from '../kitchen/AnergySelectDynamic.vue'
import ArnergySelect from '../kitchen/ArnergySelect.vue'
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  Dialog,
  RadioGroup,
  RadioButton,
  // ...
} from 'element-ui'
moment.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_'),
})

const items = []
export default {
  components: {
    ArnergyDynamic,
    'el-dialog': Dialog,
    ArnergySelect,
  },
  data() {
    return {
      searchTerm: '',
      selectOption: {
        enabled: true,
      },
      editModal: false,
      loader: false,
      form: {
        groupID: '',
        subgroup: '',
        status: false,
        emailaddress: '',
        sendtype: '',
        status2: false,
      },
      updateID: '',
      items: items,
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      sendtypes: [
        { id: 1, name: 'CC' },
        { id: 2, name: 'BCC' },
      ],

      fields: [
        {
          field: 'groupname',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'subgroupname',
          label: 'Subgroup Name',
          sortable: 'true',
        },
        {
          field: 'emailaddress',
          label: 'Email Address',
          sortable: 'true',
        },
        {
          field: 'sendtype',
          label: 'Send Type',
          sortable: 'true',
        },

        {
          field: 'status',
          label: 'Status',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      ],
      cxTeamFields: [
        {
          field: 'id',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'fu',
          label: 'Subgroup Name',
          sortable: 'true',
        },
        {
          field: 'Subgroup Description',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'Status',
          label: 'E-mail',
          sortable: 'true',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: 'gender',
          label: 'Gender',
          sortable: 'true',
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: 'phoneNumber',
          label: 'Phone Number',
          sortable: 'true',
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: 'updatedAt',
          label: 'Last Seen',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
      ],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: '',
        content: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getEmails',
      'getGroups',
      'getDummy',
      'getDevices',
    ]),
    isACxTeam: {
      get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true
        } else {
          return true
        }
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {
            text: f.label,
            value: f.key,
          }
        })
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('Do MMM YYYY')
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user,
        },
      })
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Group Updated Successfully',
        icon: 'success',
        width: '550px',
      })
    },
    updateGroup(e) {
      e.preventDefault()
      const HTTP = this.$httpUtils.instance
      const data = {
       
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        emailAddress: this.form.emailaddress,
        sendType: this.form.sendtype === "2" ? "BCC": "CC",
        status: this.form.status2,
        id: 0,
      }

      this.loader = true
      console.log(data)
      HTTP.put(`emailsetups/${this.updateID}`, data)
        .then((res) => {
          if (res.data) {
            this.editModal = false
            this.showAlert()
            this.loader = false
            this.fetchUsers()
            this.form.groupID = ''
            this.form.subgroup=""
            this.form.status2 = false;
            this.form.status= false;
            this.form.emailaddress="";
            this.form.status = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    editmodal(id) {
      this.updateID = id
      const HTTP = this.$httpUtils.instance
      const url = `/emailsetups/${id}`
      HTTP.get(url)
        .then((res) => {
          this.editModal = true
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    async getSubgroupss(id) {
      const HTTP = this.$httpUtils.instance
      let formData = new FormData()
      formData.append('groupid', id)
      let res = await HTTP.post(
        '/customerSubGroups/getCustomerSubGroupByGroupId',
        formData,
      )
        .then((res) => {
          this.subgroups = res.data
            .map((item) => {
              return {
                id: item.id,
                name: item.subgroupname,
              }
            })
            .sort((a, b) => {
              return a.name > b.name ? 1 : -1
            })
        })
        .catch((e) => {
          //
        })
      // parse for "arnergy-select" us
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance
      //  filter={"include": ["installations"]}
      const url = `/emailsetups/getEmailSetupDetail`
      HTTP.post(url)
        .then((response) => {
          const usersList = response.data
          this.$store.commit(
            'saveEmails',
            usersList.map((data) => ({
              id: data.id,
              groupname: data.groupname,
              subgroupname: data.subgroupname,
              emailaddress: data.emailaddress,
              sendtype: data.sendtype,

              status: data.status === 0 ? 'Disabled' : 'Enabled',
            })),
          )
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
  },
  mounted() {
    this.fetchUsers()
    this.groups = this.getGroups
      .map((item) => {
        return {
          id: item.id,
          name: item.groupname,
        }
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
    // console.log(this.getDummy)
  },
}
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.email-table-height {
  height: calc(100vh - 450px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/EmailInfo.vue